import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LogoutComponent } from "./auth/logout/logout.component";
import { forgotComponent } from './auth/forgot.component';
import { ResetPasswordOnceComponent } from './auth/resetpasswordOnce.component';


const routes: Routes = [
    {
        path: 'login',
        loadChildren: './auth/auth.module#AuthModule'
    },
    {
        path: 'forgot',
        component: forgotComponent
    },
    {
        path: 'changepassword',
        component: ResetPasswordOnceComponent
    },
    {
        path: 'logout', component: LogoutComponent
    },
    { path: '', redirectTo: 'home', pathMatch: 'full' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule { }


// WEBPACK FOOTER //
// D:/FMFB/FMFB Dashboard/src/app/app-routing.module.ts